(function () {
  'use strict';

  // The pack/plan/gallery purchase logic lives in
  // assets/lp-bedtime-stickers-buybox.js.liquid, shared with
  // lp-bedtime-stickers-v1 — this file only handles what's specific to the
  // ridge page itself (the sale-banner countdown timer).

  /* ---------- Countdown timer ---------- */
  (function countdown() {
    var el = document.getElementById('lpRidgeCountdown');
    if (!el) return;
    var KEY = 'sp-bedtime-ridge-sale-end';
    var end = Number(localStorage.getItem(KEY));
    var DURATION = ((1 * 24 + 12) * 60 + 45) * 60000 + 28000;
    if (!end || Date.now() > end) {
      end = Date.now() + DURATION;
      try { localStorage.setItem(KEY, String(end)); } catch (e) {}
    }
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var remaining = end - Date.now();
      if (0 >= remaining) {
        end = Date.now() + DURATION;
        try { localStorage.setItem(KEY, String(end)); } catch (e) {}
        remaining = DURATION;
      }
      var d = Math.floor(remaining / 86400000);
      var h = Math.floor((remaining % 86400000) / 3600000);
      var m = Math.floor((remaining % 3600000) / 60000);
      var s = Math.floor((remaining % 60000) / 1000);
      el.textContent = d + 'D : ' + pad(h) + 'H : ' + pad(m) + 'M : ' + pad(s) + 'S';
    }
    tick();
    setInterval(tick, 1000);
  })();
})();
